export default __webpack_public_path__ + "static/media/english-teacher.8d55232e.jpg";